import React from 'react';
import { useQuery, gql } from '@apollo/client';
import StudentDashboard from '../../components/StudentPlatform/pages/StudentDashboard';
import ApolloWrapper from './ApolloWrapper';

const GET_STUDENT_DASHBOARD = gql`
  query GetStudentDashboard {
    currentUser {
      id
      name
      email
    }
    studentProfile {
      id
      profile_completion_percentage
      profile_completed
    }
    hiringPosts(status: "published") {
      id
      slug
      title
      position_type
      location
      remote
      description
      compensation
      duration
      published_at
      firm_name
      advisor_display_name
      user {
        id
        name
        allowed_name
      }
    }
    getPersonalConversations {
      id
      participant1 {
        id
      }
      participant2 {
        id
      }
    }
  }
`;

const StudentDashboardInner = ({ companyDisplayName, brandLogoUrl, primaryColor, secondaryColor, accentColor, neutralColor }) => {
  const { loading, error, data } = useQuery(GET_STUDENT_DASHBOARD);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600">Error loading dashboard</p>
          <p className="text-gray-600 mt-2">{error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // Hiring posts already have snake_case field names from GraphQL
  const opportunities = data?.hiringPosts || [];
  
  // Get list of advisor IDs the student is already messaging
  const conversations = data?.getPersonalConversations || [];
  const currentUserId = data?.currentUser?.id;
  const messagingWithAdvisorIds = new Set(
    conversations.map(conv => {
      // Get the other participant (not the current user)
      if (conv.participant1?.id?.toString() === currentUserId?.toString()) {
        return conv.participant2?.id?.toString();
      } else {
        return conv.participant1?.id?.toString();
      }
    }).filter(Boolean)
  );

  const themeProps = { brandLogoUrl, primaryColor, secondaryColor, accentColor, neutralColor };

  return (
    <StudentDashboard
      currentUser={data?.currentUser}
      studentProfile={data?.studentProfile}
      opportunities={opportunities}
      messagingWithAdvisorIds={messagingWithAdvisorIds}
      companyDisplayName={companyDisplayName}
      {...themeProps}
    />
  );
};

const StudentDashboardContainer = ({ companyDisplayName, brandLogoUrl, primaryColor, secondaryColor, accentColor, neutralColor }) => (
  <ApolloWrapper>
    <StudentDashboardInner
      companyDisplayName={companyDisplayName}
      brandLogoUrl={brandLogoUrl}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      accentColor={accentColor}
      neutralColor={neutralColor}
    />
  </ApolloWrapper>
);

export default StudentDashboardContainer;

